module.exports = __webpack_public_path__ + "img/info.31f18297.svg";